export class DocumentoEntidade {
	public OID_DOCUMENTO: number;
	public OID_ARQUIVO_UPLOAD: number;
	public TXT_TITULO: string;
	public IND_ATIVO: string;
	public NUM_ORDEM: number;
	public OID_DOCUMENTO_PASTA?: number;
	public CD_PLANO: string;
}
